<template>
  <div class="main-project-list">
    <el-row>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.projectName"
            placeholder="项目名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.status"
            placeholder="项目状态"
            :default-first-option="true"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item id="myselfAgent">
          <select-tree
            size="small"
            :data="agentTreeData"
            clearable
            checkStrictly
            @getValue="setTreeMenu"
            :multiple="true"
            :collapseTags="true"
            :defaultKey="searchForm.agentIds"
          ></select-tree>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="createDate"
            clearable
            type="daterange"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearchProject"
            icon="el-icon-search"
            :loading="projectPager.loading"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="projectPager.tableData"
        v-loading="projectPager.loading"
        row-key="id"
        stripe
        style="width: 100%;overflow-y: auto"
        :height="tableHeight"
      >
        <el-table-column
          prop="projectName"
          label="项目名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="projectCode"
          label="项目编号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="status"
          label="项目状态"
          align="center"
          show-overflow-tooltip
          :formatter="statusFormatter"
        >
        </el-table-column>
        <el-table-column fixed="right" label="查看" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="项目机构信息"
              placement="top-start"
            >
              <el-button
                icon="el-icon-view"
                type="primary"
                size="mini"
                circle
                @click="getProjectAgentPager(scope.row.id)"
              ></el-button>
              >
            </el-tooltip>
<!--            <el-tooltip-->
<!--              class="item"-->
<!--              effect="dark"-->
<!--              content="项目链接"-->
<!--              placement="top-start"-->
<!--            >-->
<!--              <el-button-->
<!--                icon="el-icon-view"-->
<!--                type="primary"-->
<!--                size="mini"-->
<!--                circle-->
<!--                @click="viewProjectUrl(scope.row)"-->
<!--              ></el-button>-->
<!--              >-->
<!--            </el-tooltip>-->
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="projectPager.tableTotal"
      :current-page="projectPager.currentPage"
      :page-size.sync="pageSize"
      @current-change="onProjectPageChange"
      @size-change="handleSizeChange"
      :page-sizes="[20, 100, 500]"
      align="center"
    >
    </el-pagination>
    <el-dialog
      title="项目机构信息"
      :visible.sync="projectAgentVisible"
      width="30%"
    >
      <el-table
        :data="projectAgentPager.tableData"
        v-loading="projectAgentPager.loading"
      >
        <el-table-column
          prop="agentName"
          label="机构名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="agentCode"
          label="机构编号"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="项目链接" :visible.sync="projectUrlVisible" width="46%">
      <el-table :data="projectUrls">
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="projectUrl"
          label="项目链接"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div id="qrParent">
        <!--<div id="qrcodePCp">
          <div id="qrcodePC"></div>
          <el-link :underline="false" type="primary" @click="downloadPCQR('PC')"
            >PC端二维码<i class="el-icon-download el-icon&#45;&#45;right"></i
          ></el-link>
        </div>-->
        <div id="qrCodeH5p">
          <div id="qrcodeH5"></div>
          <el-link :underline="false" type="primary" @click="downloadPCQR('H5')"
            >H5端二维码<i class="el-icon-download el-icon--right"></i
          ></el-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchProjectPager, getProjectAgentPager } from "@/api/projectInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import { getAgentChildAll } from "@/api/userInfo";
import { getExamUrl } from "@/api/auth";
import QRCode from "qrcodejs2";
import { getAgentTree } from "@/api/agentInfo";
import selectTree from "@/components/selectTree";
export default {
  name: "ProjectList",
  directives: { permission },
  components: {
    selectTree
  },
  data() {
    return {
      searchForm: {
        projectName: null,
        status: null,
        agentIds: [],
        startDate: null,
        endDate: null
      },
      agentList: [],
      statusOptions: [
        { label: "未授权", value: 1 },
        { label: "已发布", value: 2 },
        { label: "已暂停", value: 3 }
      ],
      projectPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      projectInfoVisible: false,
      projectAgentVisible: false,
      agentAuthoVisible: false,
      isEditProject: false,
      createDate: [],
      agentOptions: [],
      loadingAgent: false,
      projectAgentPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      pcUrl: null,
      h5Url: null,
      projectUrlVisible: false,
      projectUrls: [],
      agentTreeData: [],
      tableHeight: 600
    };
  },
  watch: {
    createDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0];
        this.searchForm.endDate = val[1];
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
    }
  },
  created() {
    // this.projectUrlVisible = true;
    this.getAgentChildAll();
    if (localStorage.getItem("pcUrl") && localStorage.getItem("h5Url")) {
      this.pcUrl = localStorage.getItem("pcUrl");
      this.h5Url = localStorage.getItem("h5Url");
    } else {
      this.getExamUrl();
    }
    this.getAgentTree();
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
        document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setTreeMenu(key, data) {
      if (!key) {
        this.searchForm.agentIds = [];
      } else {
        this.searchForm.agentIds = key;
      }
    },
    handleSizeChange() {
      this.getProjectPager();
    },
    // 格式化账户状态
    statusFormatter(row, column, cellValue) {
      let status = {
        "1": "未授权",
        "2": "已发布",
        "3": "已暂停"
      };
      if (cellValue) {
        return status[cellValue];
      }
      return "未授权";
    },
    // 条件查询
    onSearchProject() {
      this.projectPager.currentPage = 1;
      this.searchProjectPager();
    },
    getProjectPager() {
      let that = this;
      that.projectPager.loading = true;
      searchProjectPager(this.searchForm, {
        page: this.projectPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            that.projectPager.tableTotal = Number(res.data.total);
            that.projectPager.tablePages = Number(res.data.pages);
            that.projectPager.tableData = res.data.list.map(item => {
              if (item.createDate) {
                item.createDate = that.formatTime(item.createDate);
              }
              return item;
            });
          } else {
            that.projectPager.tableTotal = 0;
            that.projectPager.tablePages = 0;
            that.projectPager.tableData = [];
          }
        })
        .finally(() => {
          that.projectPager.loading = false;
        });
    },
    searchProjectPager() {
      let that = this;
      that.projectPager.loading = true;
      searchProjectPager(this.searchForm, {
        page: this.projectPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            that.projectPager.tableTotal = Number(res.data.total);
            that.projectPager.tablePages = Number(res.data.pages);
            that.projectPager.tableData = res.data.list.map(item => {
              if (item.createDate) {
                item.createDate = that.formatTime(item.createDate);
              }
              return item;
            });
          } else {
            that.projectPager.tableTotal = 0;
            that.projectPager.tablePages = 0;
            that.projectPager.tableData = [];
          }
        })
        .finally(() => {
          that.projectPager.loading = false;
        });
    },
    // 时间格式化
    formatTime(timestamp) {
      let date = new Date(timestamp);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return (
        [year, month, day].map(this.formatNumber).join("-") +
        " " +
        [hour, minute, second].map(this.formatNumber).join(":")
      );
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    // 项目翻页
    onProjectPageChange(page) {
      this.projectPager.currentPage = page;
      this.getProjectPager();
    },
    // 跳转
    jumpPage(router) {
      this.$router.push(router);
    },
    getAgentChildAll() {
      getAgentChildAll().then(res => {
        if (res.code === 200 && res.data) {
          this.agentList = res.data;
          this.searchForm.agentIds.push(this.agentList[0].agentId);
          this.getProjectPager();
          this.projectUrlVisible = false;
        }
      });
    },
    // 查询项目机构分页
    getProjectAgentPager(id) {
      let that = this;
      this.projectAgentPager.id = id;
      that.projectPager.loading = true;
      getProjectAgentPager({
        projectId: id,
        page: this.projectAgentPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            that.projectAgentPager.tableTotal = Number(res.data.total);
            that.projectAgentPager.tablePages = Number(res.data.pages);
            that.projectAgentPager.tableData = res.data.list.map(item => {
              /*if (item.createDate) {
                item.createDate = formatDate(
                  item.createDate,
                  "yyyy-MM-dd HH:mm:ss"
                );
              }*/
              return item;
            });
          } else {
            that.projectAgentPager.tableTotal = 0;
            that.projectAgentPager.tablePages = 0;
            that.projectAgentPager.tableData = [];
          }
        })
        .finally(() => {
          this.projectAgentVisible = true;
          that.projectPager.loading = false;
        });
    },
    viewProjectUrl(row) {
      this.projectUrlVisible = true;
      var codePC = this.pcUrl + "login?projectId=" + row.id;
      var codeH5 = this.h5Url + "login?projectId=" + row.id;
      var projectUrls = [
        { projectName: row.projectName, projectUrl: codePC },
        { projectName: row.projectName, projectUrl: codeH5 }
      ];
      this.projectUrls = projectUrls;
      this.qrCode(codePC, codeH5);
    },
    qrCode(codePC, codeH5) {
      document.getElementById("qrcodeH5").innerHTML = "";
      /*let qrcodePC = new QRCode("qrcodePC", {
        width: 70,
        height: 70, // 高度
        text: "" + codePC, // 二维码内容
        image: ""
        // render: "table" // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });*/
      let H5Qrcode = new QRCode("qrcodeH5", {
        width: 70,
        height: 70, // 高度
        text: "" + codeH5, // 二维码内容
        image: ""
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      console.log(H5Qrcode);
    },
    getExamUrl() {
      getExamUrl().then(res => {
        if (res && res.code === 200) {
          if (res.data.pcUrl && res.data.gUrl) {
            localStorage.setItem("pcUrl", res.data.pcUrl);
            this.pcUrl = res.data.pcUrl;
            localStorage.setItem("gUrl", res.data.gUrl);
            this.gUrl = res.data.gUrl;
          }
          if (res.data.h5Url) {
            localStorage.setItem("h5Url", res.data.h5Url);
          }
        }
      });
    },
    downloadPCQR(param) {
      var img;
      if (param == "PC") {
        img = document.getElementById("qrcodePC").getElementsByTagName("img");
      } else {
        img = document.getElementById("qrcodeH5").getElementsByTagName("img");
      }
      var imgAttr = img[0].getAttribute("src");
      var qrBtn = document.createElement("a");
      qrBtn.href = imgAttr;
      qrBtn.download = param + "qr.png";
      qrBtn.click();
    },
    getAgentTree() {
      let that = this;
      getAgentTree(this.searchForm, {}).then(res => {
        if (res && res.code === 200) {
          that.agentTreeData = res.data;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.main-project-list {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .admin-k100 {
    width: 100%;
  }
  .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 35px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
  .search-form .el-form-item:first-child {
    width: 8%;
  }
  .search-form .el-form-item:nth-child(2) {
    width: 8%;
  }
  .search-form .el-form-item:nth-child(3) {
    width: 17%;
  }
  .search-form .el-form-item#myselfAgent .el-form-item__content {
    .el-select {
      width: 230px;
      .el-select__tags-text {
        display: inline-block;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .el-tag__close.el-icon-close {
        top: -6px;
      }
    }
  }
  #qrParent {
    position: relative;
    height: 90px;
    /*#qrcodePCp {
      width: 100px;
      height: 80px;
      position: absolute;
      left: 180px;
      margin-top: 10px;
    }*/
    #qrCodeH5p {
      width: 100px;
      height: 80px;
      position: absolute;
      right: 360px;
      margin-top: 10px;
    }
  }
}
</style>
